
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.125.625l3.75 1.25v3.75a2.5 2.5 0 001.667 2.357c.5.177.833.65.833 1.18V16.2c0 .512-.31.97-.786 1.16l-4.25 1.926c-.405.162-.865.1-1.214-.161L10 15.625v-7.5c3.125-1.25 3.125-7.5 3.125-7.5zm0 12.5h2.5M6.875.625l-3.75 1.25v3.75a2.5 2.5 0 01-1.667 2.357c-.5.177-.833.65-.833 1.18V16.2c0 .512.312.97.786 1.16l4.25 1.926c.405.162.865.1 1.214-.161l3.125-3.5v-7.5c-3.125-1.25-3.125-7.5-3.125-7.5zm0 12.5h-2.5m2.5-12.5h6.25","stroke":"currentColor","stroke-width":"1.25","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    